var chatRelativePath = '/chats';
var autoAssignRelativePath = '/auto-assign';
export var createChatApi = function (baseUrl, http) {
    var apiUrl = baseUrl + chatRelativePath;
    var autoAssignApiUrl = baseUrl + autoAssignRelativePath;
    return {
        startChat: function (startChatDto) {
            return http.post(apiUrl, startChatDto);
        },
        oldJoinChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/").concat(chatDto.chatId, "/join"), chatDto);
        },
        updateUser: function (updateChatUserDto) {
            return http.put("".concat(apiUrl, "/").concat(updateChatUserDto.chatId, "/user"), updateChatUserDto);
        },
        getParticipants: function (chatDto) {
            return http.get("".concat(apiUrl, "/").concat(chatDto.chatId, "/participants"));
        },
        oldLeaveChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/").concat(chatDto.chatId, "/leave"), chatDto);
        },
        oldEndChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/").concat(chatDto.chatId, "/end"), chatDto);
        },
        getStats: function (chatStatsDto) {
            return http.post("".concat(apiUrl, "/stats"), chatStatsDto);
        },
        getStatsExtended: function (chatStatsDto) {
            return http.post("".concat(apiUrl, "/stats/extended"), chatStatsDto);
        },
        getToken: function () {
            return http.get("".concat(apiUrl, "/token"));
        },
        addAgentReply: function (addAgentReplyDto) {
            return http.post("".concat(apiUrl, "/new/").concat(addAgentReplyDto.ticketId, "/agentMessage"), addAgentReplyDto);
        },
        joinChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/new/").concat(chatDto.ticketId, "/join"), chatDto);
        },
        leaveChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/new/").concat(chatDto.ticketId, "/leave"), chatDto);
        },
        endChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/new/").concat(chatDto.ticketId, "/end"), chatDto);
        },
        agentEndChat: function (chatDto) {
            return http.post("".concat(apiUrl, "/new/").concat(chatDto.ticketId, "/agents/end"), chatDto);
        },
        getDashboardStats: function (chatStatsDto) {
            return http.post("".concat(apiUrl, "/stats/dashboard"), chatStatsDto);
        },
        getActiveAgents: function (chatStatsDto) {
            return http.post("".concat(apiUrl, "/agents/active"), chatStatsDto);
        },
        updateChatMessage: function (updateChatMsgDto) {
            return http.put("".concat(apiUrl, "/new/").concat(updateChatMsgDto.ticketId, "/messages/").concat(updateChatMsgDto.messageId), updateChatMsgDto);
        },
        deleteChatMessage: function (chatMsgDto) {
            return http.delete("".concat(apiUrl, "/new/").concat(chatMsgDto.ticketId, "/messages/").concat(chatMsgDto.messageId));
        },
        acceptChatJob: function (autoAssignJobDto) {
            return http.post("".concat(autoAssignApiUrl, "/accept/chat"), autoAssignJobDto);
        },
        declineChatJob: function (autoAssignJobDto) {
            return http.post("".concat(autoAssignApiUrl, "/decline"), autoAssignJobDto);
        },
        startOutboundChats: function (startOutboundChatsDto) {
            return http.post("".concat(apiUrl, "/outbound"), startOutboundChatsDto);
        },
    };
};
//# sourceMappingURL=index.js.map